import { useEffect, useState } from "react";
import { api, apiErr } from "../lib/api";
import { toast } from "sonner";
import { Zap, FlaskConical, AlertTriangle } from "lucide-react";

export function ForteEnvironmentCard() {
  const [s, setS] = useState(null);
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const load = () => api.get("/payments/environment").then((r) => setS(r.data)).catch((e) => toast.error(apiErr(e)));
  useEffect(() => { load(); }, []);
  if (!s) return null;
  const live = s.env === "live";
  const switchTo = async (env) => {
    setBusy(true);
    try {
      await api.put("/payments/environment", { env, confirm });
      toast.success(env === "live" ? "Forte is now LIVE — real money moves on Fund & pay." : "Forte switched to sandbox.");
      setConfirm(""); load();
    } catch (e) { toast.error(apiErr(e)); } finally { setBusy(false); }
  };
  return (
    <div className={`border p-6 max-w-3xl mb-6 ${live ? "border-red-600 bg-red-50/40" : "border-border bg-white"}`} data-testid="forte-env-card">
      <h2 className="font-bold tracking-tight flex items-center gap-2">{live ? <Zap className="h-4 w-4 text-red-600" /> : <FlaskConical className="h-4 w-4" />} Forte environment: <span data-testid="forte-env-current" className={`font-mono uppercase ${live ? "text-red-700" : ""}`}>{s.env}</span></h2>
      <p className="text-xs text-muted-foreground mt-1">
        {live ? "Real pre-authorized debits and employee credits are submitted on Fund & pay." : "Sandbox — nothing is debited or paid for real."}
        {s.set_by ? ` Set by ${s.set_by} on ${String(s.set_at).slice(0, 10)}.` : ""}
      </p>
      <div className="mt-3 text-xs flex gap-4">
        <span data-testid="forte-sandbox-configured">Sandbox credentials: <b>{s.sandbox_configured ? "set" : "missing"}</b></span>
        <span data-testid="forte-live-configured">Live credentials: <b>{s.live_configured ? "set" : "missing"}</b></span>
      </div>
      <div className="mt-4 flex flex-wrap items-center gap-3">
        {live ? (
          <button data-testid="forte-env-to-sandbox" onClick={() => switchTo("sandbox")} disabled={busy} className="text-xs border border-black px-3 py-1.5 hover:bg-black hover:text-white transition-colors disabled:opacity-50">Switch to sandbox</button>
        ) : (
          <>
            <input data-testid="forte-env-confirm" value={confirm} onChange={(e) => setConfirm(e.target.value)} placeholder='Type LIVE to confirm' className="border border-input bg-white px-3 py-1.5 text-xs w-44 focus:outline-none focus:ring-2 focus:ring-red-600" />
            <button data-testid="forte-env-to-live" onClick={() => switchTo("live")} disabled={busy || confirm !== "LIVE" || !s.live_configured} className="text-xs bg-red-600 text-white px-3 py-1.5 hover:bg-red-700 disabled:opacity-40">Go LIVE</button>
          </>
        )}
      </div>
      <p className="mt-3 text-[11px] text-amber-800 flex items-start gap-1"><AlertTriangle className="h-3.5 w-3.5 mt-0.5 shrink-0" /> Forte tokens are environment-specific: after switching, every client funding account and every employee's direct deposit must be re-entered (they show as "Re-enter bank details" until then). Test companies can never move live money.</p>
    </div>
  );
}
